import React from "react";
import { useParams } from "react-router-dom";
import { blogData } from "../data/blogData";
import Header from "../components/Header";
import Footer from "../components/Footer";
import BlogInfo from "../components/BlogInfo";

export default function BlogDetail() {
  const { id } = useParams(); // obtiene el ID desde la URL
  const blog = blogData[id]; // busca el blog según el índice

  if (!blog) {
    return <p style={{ textAlign: "center", marginTop: "50px" }}>Blog no encontrado</p>;
  }

  return (
    <main style={{ fontFamily: "Inter, Roboto, sans-serif", color: "#222", background: "#fff" }}>
      <Header />
      <BlogInfo blog={blog} />
      <Footer />
    </main>
  );
}
